import { useMemo } from "react";
import { useReducers } from "../../../shared/hooks/useReducer";
import PlayerConstants from "../../../shared/constants/player";
import constants from "../../../shared/constants";
const { REDUCER_TYPE } = constants;

const { LIVE, VOD, RECORDING } = PlayerConstants.PLAYER_TYPE;

const usePlayerVars = (props) => {
  const { onDemandPlayerData } = useReducers(REDUCER_TYPE.ON_DEMAND_PLAYER);
  const { streamInfo, type, metadataInfo, nextProgramInfo } = props;
  const { assetId, externalContentId } = streamInfo;
  const seriesDetails = useMemo(
    () => (type !== LIVE ? onDemandPlayerData?.seriesDetails : null),
    [type, onDemandPlayerData]
  );
  const { title, subTitle, image, channelNumber, bgImage, extendedMetadata, recordingDeltaTime } = metadataInfo;
  const { nextProgram, nextEpisodePoster, loadNextProgram } = nextProgramInfo;

  return {
    assetId,
    externalContentId,
    seriesDetails,
    title,
    subTitle,
    image,
    channelNumber,
    bgImage,
    extendedMetadata,
    recordingDeltaTime,
    nextProgram,
    nextEpisodePoster,
    loadNextProgram,
  };
};

const usePlayerClassNames = (className) => {
  const playerLoaderClassName = `loader-wrapper ${className}`;
  const videoClassName = `${className} videoPlayer`;
  const videoControlsName = `${className} videoControls`;

  return {
    playerLoaderClassName,
    videoClassName,
    videoControlsName,
  };
};

const useContentType = (type) => {
  const isVOD = type === VOD;
  const isRecording = type === RECORDING;
  const isOnDemandType = type === VOD || type === RECORDING;

  return {
    isVOD,
    isRecording,
    isOnDemandType,
  };
};

export { usePlayerVars, usePlayerClassNames, useContentType };
